import {
  reverb_search_Filter,
} from '../schemas/rql';
import { renameParams } from '@reverbdotcom/commons/src/facet_utils';
import { isBrandPage, isShopPage, isSimilarItemPage } from '@reverbdotcom/commons/src/url_helpers';
import { Location } from 'history';
import { renameRqlParam } from './shared/rql_param_helper';

// Given an array of all listing filters from a graphql query,
// returns only relevant filters (and filter options) to display,
// based on the current user (experiment groups) and URL (brand page, shop page, marketplace, CSP).
export function listingsFilters(
  filters: reverb_search_Filter[],
  location: Location,
): reverb_search_Filter[] {
  // Removes the 'combined_shipping' option from the
  // `Show Only` || `Find a Deal` filter if not viewing a shop page
  if (!isShopPage(location)) {
    filters = filters.map((filter) => {
      if (filter.key !== 'SHOW_ONLY' && filter.key !== 'FIND_A_DEAL') {
        return filter;
      }

      return {
        ...filter,
        options: filter.options.filter((o) => o.paramName !== 'combined_shipping'),
      };
    });
  }

  // Removes the sidebar keyword search when viewing a brand or similar item page
  if (isBrandPage(location) || isSimilarItemPage(location)) {
    filters = filters.filter(filter => filter.key !== 'TEXT_QUERY');
  }

  return renameParams(filters, renameRqlParam);
}
